import { render } from "./CatalogPagination.vue?vue&type=template&id=f3bd1df4"
import script from "./CatalogPagination.vue?vue&type=script&lang=js"
export * from "./CatalogPagination.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__